/**
 * 存放VSS全局变量
 */
export const SUB_APP_PREFIX = "/vss";

/**
 * 页面所属系统类型: 0-商品供应商，1-劳动力 accountType
 * 登录人拥有：0商户账户 1劳动力商户账户 2商户账户&劳动力商户
 */
export const ACCOUNT_TYPE = {
  RENXIAO: 1,
  SUPPLIER: 0,
  SUPPLIER_AND_RENXIAO: 2,
};

/**
 * VSS账户类型：目前有2种账户类型，0: 商品供应商账户，1: 劳动力供应商账户。 一个账号可以同时拥有 2 个账户类型。
 */
export const VSS_ACCOUNT_TYPE = [
  {
    label: "商品供应协同平台",
    code: 0,
    to: "/partner/index.html",
  },
  {
    label: "劳动力协同平台",
    code: 1,
    to: "/partner/renxiao/index.html",
  },
];

export const ACCOUNT_TYPE_MAP = VSS_ACCOUNT_TYPE.reduce((pre, cur) => {
  pre[cur.code] = cur.label;
  return pre;
}, {});

export const YX_FE_MICRO_PREFIX = "micro";
